(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewRoutes', [
            'recomActionPlanUpdateStatusReviewControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider

           .state('recomActionPlanUpdateStatusReview', {
                url: '/RecomActionPlanUpdateStatus/Review/User@{ItemPersonID:int}/{BusinessUnitCode:string}',
                resolve: {
                    bUnit: ['$stateParams', 'recomService', function ($stateParams, service) {
                        return service.getBusinessUnitByCode($stateParams.BusinessUnitCode);
                    }],
                    govProcess: ['bUnit', 'recomService', function (bUnit, service) {
                        return service.getActiveGovernanceProcessByRecomBusinessUnit(bUnit.RecomBusinessUnitID);
                    }],
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent" class="initiative-update-status" autoscroll="true"></div>',
                    },
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        controller: 'RecomActionPlanUpdateStatusReviewController'
                    }
                }
            })

           .state('recomActionPlanUpdateStatusReview.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        templateUrl: require('./noActiveProcess.tpl.html'),
                    }
                }
            })

           .state('recomActionPlanUpdateStatusReview.actionPlans', {
                resolve: {
                    actionPlansByAssessor: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                        return service.getActionPlanAssessmentsToReviewByAssessor(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID);
                    }],
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        controller: 'RecomUpdateStatusAssessActionPlansToReviewListController'
                    }
                }
            })

           .state('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias', {
               url: '/ActionPlan/{ActionPlanID:int}/Criterias',
               resolve: {
                   assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService',
                                            function ($stateParams, bUnit, service) {
                                                return service.getAssessmentsToReviewByAssessorAndActionPlan(bUnit.RecomBusinessUnitID,
                                                                                                             $stateParams.ItemPersonID,
                                                                                                             $stateParams.ActionPlanID);
                                            }],
                   fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                       var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                           .map(function (critAssess) {
                               return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                           })
                           .uniq()
                           .value();

                       return fiscalYearQuarterKeys;
                   }]
               },
               views: {
                   'mainContent@recomActionPlanUpdateStatusReview': {
                       controller: 'RecomUpdateStatusAssessByActionPlanCriteriasToReviewController',
                       templateUrl: require('./byActionPlanCriterias.tpl.html'),
                   }
               }
           })

           .state('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter', {
                url: '/ActionPlan/{ActionPlanID:int}/Criterias/Quarter/{FiscalYearQuarterKey}',
                params: {
                    toPrevious: { value: undefined },
                    toNext: { value: undefined }
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        templateUrl: require('./byQuarter.tpl.html'),
                        controller: 'RecomUpdateStatusAssessByQuarterReviewController',
                        resolve: {
                            assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService',
                                                     function ($stateParams, bUnit, service) {
                                                         return service.getAssessmentsToReviewByAssessorAndActionPlan(bUnit.RecomBusinessUnitID,
                                                                                                                      $stateParams.ItemPersonID,
                                                                                                                      $stateParams.ActionPlanID);
                                                     }],
                            fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                                var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                                    .map(function (critAssess) {
                                        return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();

                                return fiscalYearQuarterKeys;
                            }],
                            criteriaAssessmentsByQuarter: ['$stateParams', 'assessmentsByActionPlan', function ($stateParams, assessmentsByActionPlan) {
                                return _.filter(assessmentsByActionPlan.ActionPlanCriteriaAssessments, {
                                    ActionPlanCriteria: { TargetFiscalYearAndQuarter: $stateParams.FiscalYearQuarterKey }
                                });
                            }]
                        }
                    }
                },
            })

           .state('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanNoCriterias', {
                url: '/ActionPlan/{ActionPlanID:int}/NoCriteria',
                resolve: {
                    assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                        return service.getAssessmentsToReviewByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                    }],
                    fiscalYearQuarterKeys: [function () {
                        return [];
                    }]
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        controller: 'RecomUpdateStatusAssessByActionPlanCriteriasToReviewController',
                        templateUrl: require('./byActionPlanNoCriterias.tpl.html'),
                    }
                }
            })

           .state('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanAssessment', {
                url: '/ActionPlan/{ActionPlanID:int}',
                views: {
                    'mainContent@recomActionPlanUpdateStatusReview': {
                        templateUrl: require('./byActionPlan.tpl.html'),
                        controller: 'RecomUpdateStatusAssessByActionPlanReviewController',
                        resolve: {
                            assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                                return service.getAssessmentsToReviewByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                                var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                                    .map(function (critAssess) {
                                        return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();

                                return fiscalYearQuarterKeys;
                            }],
                        }
                    }
                }
           });

            // History Context
            historyCtxtServiceProvider.setCtxtState('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias',
                '/app/Main/recomActionPlanStatusUpdate/review/GOVHistoryCtxtDirective-recomStatusUpdate.tpl.html'
            );

            historyCtxtServiceProvider.setCtxtState('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter',
                '/app/Main/recomActionPlanStatusUpdate/review/GOVHistoryCtxtDirective-recomStatusUpdate.tpl.html'
            );

            historyCtxtServiceProvider.setCtxtState('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanNoCriterias',
                '/app/Main/recomActionPlanStatusUpdate/review/GOVHistoryCtxtDirective-recomStatusUpdate.tpl.html'
            );

            historyCtxtServiceProvider.setCtxtState('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanAssessment',
                '/app/Main/recomActionPlanStatusUpdate/review/GOVHistoryCtxtDirective-recomStatusUpdate.tpl.html'
            );
    }
})();